"use client";
import { usePathname } from "next/navigation";
import { fabFor } from "@/lib/fab";
import { Fab } from "./Fab";
import { FeedbackWidget } from "./FeedbackWidget";

/** The floating pieces: the page's "+" (bottom-right) and Feedback (bottom-left).
 *  Both are for a signed-in member, so neither shows on the login screen, on the
 *  public share pages under /s/, or on the invitation pages under /invite/.
 *  lib/fab.ts decides what "+" does per page, and hides it where there is nothing
 *  to add. (The upload status lives in each header instead: see QueueStatus.) */
export function Floaters() {
  const pathname = usePathname();
  if (pathname === "/login" || pathname.startsWith("/login/") || pathname.startsWith("/s/") || pathname.startsWith("/invite/")) return null;
  const action = fabFor(pathname);
  return (
    <>
      {action && <Fab action={action} />}
      <FeedbackWidget />
    </>
  );
}
